/**
 * Validation constants for Goal
 */ (function(GoalConstants) {
    GoalConstants.NameMaxLength = 255;
    GoalConstants.MaxAttachableResources = 10;
    GoalConstants.MaxGroundingFilesToShowInUX = 3;
    GoalConstants.MaxGoals = 25;
    GoalConstants.MaxTasksInGoalsGridView = 10;
    GoalConstants.DefaultGoalPriority = 5;
})(GoalConstants || (GoalConstants = {}));
/**
 * Enum to update goal fields on partial IGoal
 */ export var EditableGoalFieldKeys = /*#__PURE__*/ function(EditableGoalFieldKeys) {
    EditableGoalFieldKeys["Name"] = "displayName";
    EditableGoalFieldKeys["FinishDate"] = "finishDate";
    EditableGoalFieldKeys["Status"] = "status";
    EditableGoalFieldKeys["Extensions"] = "extensions";
    EditableGoalFieldKeys["StartDate"] = "startDate";
    EditableGoalFieldKeys["Notes"] = "notes";
    EditableGoalFieldKeys["Priority"] = "priority";
    return EditableGoalFieldKeys;
}({});
/**
 * The number of loading tasks shimmer rows in the goals grid.
 * This is used to show a placeholder while the tasks are being loaded.
 */ export const NumberOfLoadingTasksShimmerRowsInGoalsGrid = 3;
export var GoalConstants;
